import React from 'react'
import { Platform, TextStyle, View, ViewStyle } from 'react-native'

import { iconCheck, iconClose } from '../../assets/icons'
import { SvgIcon } from '../svg-icon'
import { Text } from '../text'

export const ReviewOpenText = (props: any) => {
  const { question, style, branding } = props
  const userChoiceID = question?.user_answer_choices[0]?.choice_id
  const selected = question?.question_answer_choices.find((c) => c.choice_id === userChoiceID)
  const actual = question?.question_answer_choices.find((c) => c.correct)

  return (
    <View style={{ flexDirection: 'column', gap: 20, ...style }}>
      {!question.correct && (
        <View
          style={{
            ...OPEN_TEXT_ANS,
            borderColor: branding.incorrect_answer,
            backgroundColor: branding.feedback_background,
          }}
        >
          {Platform.OS === 'web' ? (
            <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
              <path
                fill={branding.incorrect_answer}
                d="M18.3 5.71a.996.996 0 00-1.41 0L12 10.59 7.11 5.7A.996.996 0 105.7 7.11L10.59 12 5.7 16.89a.996.996 0 101.41 1.41L12 13.41l4.89 4.89a.996.996 0 101.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
              />
            </svg>
          ) : (
            <SvgIcon size="24" src={iconClose} color={branding.incorrect_answer} />
          )}
          <Text
            disableLink
            style={{ ...CHOICE_TEXT, color: branding.incorrect_answer }}
            text={selected.choice_text}
          />
        </View>
      )}
      <View
        style={{
          ...OPEN_TEXT_ANS,
          borderColor: branding.correct_answer,
          backgroundColor: branding.feedback_background,
        }}
      >
        {Platform.OS === 'web' ? (
          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
            <path
              fill={branding.correct_answer}
              d="M8.795 15.875l-3.47-3.47a.996.996 0 10-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.58-10.58a.996.996 0 10-1.41-1.41l-9.88 9.87z"
            />
          </svg>
        ) : (
          <SvgIcon size="24" src={iconCheck} color={branding.correct_answer} />
        )}
        <Text
          disableLink
          style={{ ...CHOICE_TEXT, color: branding.correct_answer }}
          text={actual.choice_text}
        />
      </View>
    </View>
  )
}
const CHOICE_TEXT: TextStyle = {
  paddingLeft: 18,
  fontSize: 14,
  alignSelf: 'center',
  flex: 1,
}
const OPEN_TEXT_ANS: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center',
  display: 'flex',
  paddingHorizontal: 12,
  paddingVertical: 14,
  borderWidth: 1,
  borderRadius: 12,
  flex: 1,
}
